import { Camera } from './../_shared/models/camera.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class VideoStreamProviderService {

    constructor(
        private httpClient: HttpClient
    ) { }


    getVideoStreamProviderList() {
        return this.httpClient.get<any>('api_endpoint' + `/video-stream/index`);
    }

    getVideoStream(videoStreamProviderId: string) {
        return this.httpClient.get<any>('api_endpoint' + `/video-stream/${videoStreamProviderId}`);
    }

    updateCameras(partner: string, receiverToken: string) {
        return this.httpClient.post<any>('api_endpoint' + `/video-stream/update-cameras`, {partner, receiverToken});
    }
    
    updateMatchCameras(partner: string, receiverToken: string, matchId: string) {
        return this.httpClient.post<any>('api_endpoint' + `/v2/video-stream/update-cameras`, {partner, receiverToken, matchId});
    }

    saveCameraToMatch(camera: Camera, matchId: string, removeOldCameras: boolean, updateCourtName: boolean, keepVideoLink: boolean) {
        return this.httpClient.post<any>('api_endpoint' + `/video-stream/save-match-cameras`, {camera, matchId, removeOldCameras, updateCourtName, keepVideoLink});
    }

    removeCamera(camera: Camera, matchId: string) {        
        return this.httpClient.post<any>('api_endpoint' + `/video-stream/remove-camera`, {camera, matchId});
    }

    removeFacility(videoStreamSettingsId: string) {        
        return this.httpClient.post<any>('api_endpoint' + `/video-stream/remove-facility`, { videoStreamSettingsId });
    }
}
